import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
//import "./libs/swiper.js";
import "./libs/swiper_v.5.4.1.js";

import {binder, fwa} from "./libs/binder";
import {constants} from "./modules/module";
import {customSelect} from "./modules/custom-select";
import {header} from "./modules/header";
import {footer} from "./modules/footer";
import {popups} from "./modules/popups";
import {addAnimations} from "./modules/add-animations";
import {goToAnchor, scrollToHash} from "./modules/go-to-anchor";
import {adaptiveBg} from "./modules/adaptive-bg";
import {accordion} from "./modules/accordion";
import {benefitsSlider} from "./modules/benefitsSlider";
import {stickyTestimonialsSlider} from "./modules/stickyTestimonialsSlider";
import {hireTopSlider} from "./modules/hire-top-slider";
import {latestNewsSlider} from "./modules/latestNewsSlider";
import {mediaInfoTestimonials} from "./modules/mediaInfoTestimonials";
import {statisticsList} from "./modules/statisticsList";
import {imageGallery} from "./modules/image-gallery";
import {helpCenter} from "./modules/help-center";
import {hireTopSliderMobile} from "./modules/hire-top-slider-mobile";
import {manageSlider} from "./modules/manage-slider";
import {howWorkSlider} from "./modules/how-work-slider";
import {tabbedSection} from "./modules/tabbed-section";
import {animationOnScroll} from "./modules/animationOnScroll";
import {parallax} from "./modules/parallax";
import {compareHolderHeight} from "./modules/compareHolderHeight";

binder({
    bounds: {
        "html": [constants, popups, scrollToHash],
        ".header": header,
        ".footer": footer,
        "select, .jcf-scrollable": customSelect,
        "[data-goto-anchor], .anchors": goToAnchor,
        ".has-animation": [addAnimations, animationOnScroll],
        ".adaptive-bg": adaptiveBg,
        ".accordion": accordion,
        ".benefits-slider": benefitsSlider,
        ".sticky-testimonials-list .slider": stickyTestimonialsSlider,
        ".hire-top-grid": [hireTopSlider, hireTopSliderMobile],
        ".latest-insights-slider": latestNewsSlider,
        ".media-info-testimonials": mediaInfoTestimonials,
        ".statistics-list": statisticsList,
        ".image-gallery": imageGallery,
        ".help-center": helpCenter,
        ".manage-section": manageSlider,
        ".how-work-slider": howWorkSlider,
        ".tabbed-section": tabbedSection,
        ".parallax": parallax,
        ".comparison-holder": compareHolderHeight
    },
    runTests: false
});

(function () {
    document.addEventListener('wpcf7mailsent', function () {
        let $formHolder = $('.splash-form-holder');

        $formHolder.find('.sign-up').fadeOut(400, function () {
            $formHolder.find('.thanks-block').fadeIn();
        });
    }, false);
})();

$(document).on("click", function (e) {
    if (!$(e.target).closest(".search-panel").length) {
        $('.search-panel').removeClass('show-dropdowm');
    }
})


// WEBPACK FOOTER //
// ./assets/js/global.js